export enum UrlType {
	LinkedInProfessionalProfile = "LinkedInProfessionalProfile",
	ProfessionalWebsite = "ProfessionalWebsite",
	Portfolio = "Portfolio",
	ProfessionalXProfile = "ProfessionalXProfile",
	FacebookEntrepriseProfile = "FacebookEntrepriseProfile",
	InstagramProfessionalProfile = "InstagramProfessionalProfile",
	ProfessionalYoutubeChannel = "ProfessionalYoutubeChannel",
	PersonalBlog = "PersonalBlog"
}
